export const selectRackCabinet = {
  data () {
    return {
    }
  },
  methods: {
    getRack (akumulatory, stale, dodatkowe, inputRack) {
      var sumaH600 = (akumulatory['600'] !== null) ? (akumulatory['600'].height + stale + dodatkowe) : 0
      var sumaH800 = (akumulatory['800'] !== null) ? (akumulatory['800'].height + stale + dodatkowe) : 0 // akumulatory['800'].height + stale + dodatkowe
      var wysokoscSzafy = 0
      var aDepth = []
      var item = []

      var matchSzafa600 = []
      var matchSzafa800 = []
      var selectedSzafa = []

      matchSzafa600 = this.ListaSzafy.filter(item => ((item.attributes.wysokosc * 3) >= sumaH600 && Number(item.attributes.glebokosc) === Number(600)))
      matchSzafa800 = this.ListaSzafy.filter(item => ((item.attributes.wysokosc * 3) >= sumaH800 && Number(item.attributes.glebokosc) === Number(800)))

      if (matchSzafa600[0] && matchSzafa800[0]) {
        // console.log(matchSzafa600[0].kod, matchSzafa800[0].kod)
        if (matchSzafa600[0].attributes.wysokosc > matchSzafa800[0].attributes.wysokosc) {
          selectedSzafa = matchSzafa800[0]
        } else {
          selectedSzafa = matchSzafa600[0]
        }
      } else {
        if (matchSzafa600[0]) {
          selectedSzafa = matchSzafa600[0]
        } else if (matchSzafa800[0]) {
          selectedSzafa = matchSzafa800[0]
        }
      }

      if (selectedSzafa && selectedSzafa.attributes) {
        wysokoscSzafy = selectedSzafa.attributes.wysokosc

        for (item in matchSzafa600) {
          if (matchSzafa600[item] && matchSzafa600[item].attributes.wysokosc === wysokoscSzafy) {
            aDepth.push(matchSzafa600[item].attributes.glebokosc)
          }
        }
        for (item in matchSzafa800) {
          if (matchSzafa800[item] && matchSzafa800[item].attributes.wysokosc === wysokoscSzafy) {
            aDepth.push(matchSzafa800[item].attributes.glebokosc)
          }
        }

        if (inputRack.active) {
          if (matchSzafa600[0] && (inputRack.value === 600 || inputRack.value === '600')) {
            selectedSzafa = matchSzafa600[0]
          }
          if (matchSzafa800[0] && (inputRack.value === 800 || inputRack.value === '800')) {
            selectedSzafa = matchSzafa800[0]
          }
        }
        // console.log(aDepth)

        return {'szafa': selectedSzafa, 'akumulator': akumulatory[selectedSzafa.attributes.glebokosc], 'glebokosc': aDepth}
      } else {
        return {}
      }
    },
    getBatteries (pojemnosc) {
      var matchBatteries600 = []
      var matchBatteries800 = []
      var temp600 = JSON.parse(JSON.stringify(this.ListaAkumulatory))
      var temp800 = JSON.parse(JSON.stringify(this.ListaAkumulatory))

      temp600.filter(item600 => {
        if (item600.pojemnosc >= pojemnosc && item600.glebokosc.indexOf('600') > -1) {
          item600.label = item600.kod + ', ' + (Number(item600.ilosc) / 2) + 'x ciąg, poj: ' + item600.pojemnosc + 'Ah'
          item600.height = item600.wysokosc * 3
          item600.depth = 600
          matchBatteries600.push(item600)
        }
      })

      temp800.filter(item800 => {
        if (item800.pojemnosc >= pojemnosc && item800.glebokosc.indexOf('800') > -1) {
          item800.label = item800.kod + ', ' + (Number(item800.ilosc) / 2) + 'x ciąg, poj: ' + item800.pojemnosc + 'Ah'
          item800.height = item800.wysokosc * 3
          item800.depth = 800
          matchBatteries800.push(item800)
        }
      })

      return {'600': (matchBatteries600[0]) ? matchBatteries600[0] : null, '800': (matchBatteries800[0]) ? matchBatteries800[0] : null}
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/selectRackCabinet.js